var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIco({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.98438 14.0156L15.9844 5.01562L14.5781 3.5625L6.98438 11.1562L3.42188 7.59375L2.01562 9L6.98438 14.0156ZM15.9844 0C16.5469 0 17.0156 0.203125 17.3906 0.609375C17.7969 1.01562 18 1.48438 18 2.01562V15.9844C18 16.5156 17.7969 16.9844 17.3906 17.3906C17.0156 17.7969 16.5469 18 15.9844 18H2.01562C1.45312 18 0.96875 17.7969 0.5625 17.3906C0.1875 16.9844 0 16.5156 0 15.9844V2.01562C0 1.48438 0.1875 1.01562 0.5625 0.609375C0.96875 0.203125 1.45312 0 2.01562 0H15.9844Z",
    fill: "#00A082"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIco);
export default __webpack_public_path__ + "static/media/checkIco.42113288b4a91adc241cfbd921737934.svg";
export { ForwardRef as ReactComponent };